import { render, staticRenderFns } from "./RestaurantConfiguration.vue?vue&type=template&id=77e946c3"
import script from "./RestaurantConfiguration.vue?vue&type=script&lang=js"
export * from "./RestaurantConfiguration.vue?vue&type=script&lang=js"
import style0 from "./RestaurantConfiguration.vue?vue&type=style&index=0&id=77e946c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports